import React from "react";
import "./styles/TermsOfService.css"; // ✅ Import the CSS for styling

const TermsOfService = () => {
  return (
    <div className="policy-container">
      <h1>Terms of Service</h1>
      <p>Last Updated: March 15, 2025</p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to <strong>Next Remedy Automated Fan Creator</strong> (the “Service” or “App”).
        This Service is provided by Next Remedy (“we,” “us,” or “our”).
        These Terms of Service (“Terms”) govern your access to and use of the App,
        including any content, functionality, and services offered through it.
        By creating an account or otherwise using the Service, <strong>you agree to be
        bound by these Terms and our <a href="/privacy-policy">Privacy Policy</a></strong>.
        If you do not agree with these Terms, you must not use the App.
      </p>

      <h2>2. Eligibility</h2>
      <p>
        You must be at least <strong>18 years old</strong> to use this Service. 
        If you are using the App on behalf of a company, you represent that you have the authority
        to bind that entity to these Terms.
      </p>

      <h2>3. User Responsibilities</h2>
      <ul>
        <li>You will not misuse the platform for spam, bulk emailing, or any form of solicitation.</li>
        <li>You will comply with applicable email marketing laws (CAN-SPAM Act, GDPR, etc.).</li>
        <li>You will not upload malware, attempt hacking, or interfere with platform security.</li>
      </ul>

      <h2>4. Services Provided</h2>
      <p>
        The App enables **automated email outreach** to potential fans using hashtags from 
        social media. The features include:
      </p>
      <ul>
        <li><strong>Email Outreach Automation</strong> – Send targeted email campaigns.</li>
        <li><strong>Hashtag-Based Scraping</strong> – Gather publicly available emails.</li>
        <li><strong>Campaign Dashboard</strong> – Track emails sent, open rates, and engagement.</li>
      </ul>

      <h2>5. Payment & Refund Policy</h2>
      <p>
        Payments are processed securely via Stripe/PayPal.
        Refunds are provided only in specific cases, as outlined in the refund policy.
      </p>

      <h2>6. Data Usage & Privacy</h2>
      <p>
        Your personal information is protected under our 
        <a href="/privacy-policy"> Privacy Policy</a>.
      </p>

      <h2>7. Compliance with Google Policies</h2>
      <p>
        If you sign in using Google, you must comply with Google’s terms and API usage policies.
      </p>

      <h2>8. Contact Information</h2>
      <p>
        If you have any questions, contact us at:
        <a href="mailto:paulavictoriano@nextremedy.net">paulavictoriano@nextremedy.net</a>.
      </p>
    </div>
  );
};

export default TermsOfService;